import { combineReducers } from 'redux';
import layout from './layout';
import modal from './modal';

const rootReducers = combineReducers({ layout, modal });

export type RootState = ReturnType<typeof rootReducers>;

export default rootReducers;
